import router from "./router";
import store from "@/store";
import SERVICE_ROUTER from "@/constants/ROUTER_DATA/SERVICE_DATA";
import INVOICE_ROUTER from "@/constants/ROUTER_DATA/INVOICE_DATA";
import VueCookies from "vue-cookies";
import NProgress from "nprogress"; // progress bar
import "@/assets/less/nprogress.less"; // progress bar style
import { ACCESS_TOKEN } from "@/store/mutation-types";
import { setDocumentTitle } from "@/utils/domUtil";
import { ANCHOR_DATA } from "@/constants/ROUTER_DATA";
NProgress.configure({ showSpinner: false });
//白名单
const whiteList = [
  "cancellationFill",
  "cancellationInfo",
  "cancellationAccount",
  "cancellationStatus",
  "index",
  "login",
  "findPassword",
  "findAccount",
  "registered",
  "gameHome",
  "appeal",
  "tel",
  "appealSubmit",
  "appealFind",
  "phoneRegister"
];
//设置APP名称
function setAppTitle(to) {
  const TITLE = "极致游戏_极致游戏官方网站";
  setDocumentTitle(
    to.meta && !to.meta.title ? `${to.meta.title} - ${TITLE}` : `${TITLE}`
  );
}

//根据token进入页面
function handlerRouterEnter(to, next) {
  let APP_TOKEN = VueCookies.get(ACCESS_TOKEN);
  let redirectRouter = "";

  if (to.fullPath.indexOf("invoice") !== -1) {
    redirectRouter = "/invoiceRules";
  } else {
    redirectRouter = to.fullPath;
  }

  if (APP_TOKEN) {
    // 存储token
    !store.getters.token && store.commit("SET_TOKEN", APP_TOKEN);

    //登陆跳往个人中心首页
    if (to.path === ANCHOR_DATA.login.path) {
      next({ path: ANCHOR_DATA.profile.path });
      NProgress.done();
      return false;
    }

    //安全权限拦截
    if (to.meta.requiresAuth) {
      store
        .dispatch("GetInfo")
        .then(() => {
          next();
        })
        .catch(() => {
          store.dispatch("Logout", true).then(() => {
            next({
              path: ANCHOR_DATA.login.path,
              query: { redirect: redirectRouter }
            });
          });
        });
      return false;
    }

    next();
  } else {
    // 在免登录白名单，直接进入
    if (whiteList.includes(to.name)) {
      if (window._hmt) {
        if (to.path) {
          window._hmt.push(["_trackPageview", "/#" + redirectRouter]);
        }
      }
      next();
    } else {
      next({
        path: ANCHOR_DATA.login.path,
        query: { redirect: redirectRouter }
      });
      NProgress.done();
    }
  }
}

//控制底部显示
function hiddenFooter(to) {
  let routers = [
    ...Object.keys(SERVICE_ROUTER),
    ...Object.keys(INVOICE_ROUTER),
    "cancellationAccount"
  ];
  let dom = document.getElementsByClassName("jz-general-footer");
  dom[0].style.display =
    to.name && routers.includes(to.name) ? "none" : "block";
}

router.beforeEach((to, from, next) => {
  NProgress.start();
  setAppTitle(to);
  handlerRouterEnter(to, next);
});

router.afterEach(to => {
  window._jzGeneral.then(data => {
    hiddenFooter(to);

    // 检查置灰配置
    if (data.style) {
      const styleArr = data.style.split(",");
      if (!styleArr.includes("gray")) return;
      const className = document.getElementsByTagName("html")[0].className;
      const classNameArr = className.split(" ");

      // 判断当前页面是否首页，首页要支持
      if (styleArr.includes("index")) {
        if (to.name === "index") {
          // 添加置灰
          document.getElementsByTagName("html")[0].className = `${
            className ? `${className} ` : ""
          }style-gray`;
        } else if (classNameArr.includes("style-gray")) {
          // 移除置灰
          document.getElementsByTagName(
            "html"
          )[0].className = classNameArr
            .filter(el => el !== "style-gray")
            .join(" ");
        }
      } else {
        // 全站置灰
        document.getElementsByTagName("html")[0].className = `${
          className ? `${className} ` : ""
        }style-gray`;
      }
    }
  });
  NProgress.done();
});
